import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/named */
import { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import MultiSelectSortable, { ReactSelectOption } from './SortableSelect';

export interface ArticlesMultiSelectorProps {
  readOnly?: boolean;
  selectedArticles?: ReactSelectOption[];
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
}

export default (props: ArticlesMultiSelectorProps) => {
  const spd = useSpdCore();
  const [articles, setArticles] = useState<ReactSelectOption[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.articles
      .getAll()
      .then(t => {
        if (mounted) {
          const result = t.map(
            a =>
              ({
                value: a.id,
                label: a.description,
              }) as ReactSelectOption,
          );
          setArticles(result);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem artykułów. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.articles]);

  return ready ? (
    <MultiSelectSortable
      options={articles}
      defaultValue={props.selectedArticles || []}
      onChange={options => props.onChange && props.onChange(options)}
    />
  ) : (
    <Skeleton />
  );
};
